import { css } from "@emotion/css"

import ImageButton from "@p-ban/common/src/components/html/ImageButton"

import question from "./question.png"
import questionHover from "./question_hover.png"

const Question = (props: JSX.IntrinsicElements["button"]) => {
  return (
    <ImageButton
      {...props}
      className={style}
      src={question}
      hoverSrc={questionHover}
      alt="ヘルプ"
      width={12}
      height={12}
    />
  )
}

export default Question

const style = css`
  display: flex;
  width: 12px;
  height: 12px;
  background-color: transparent;
`
